<template>
  <div>
    <h2>{{$t("subject_details.bidding_notice")}}</h2>
    <div class="xuzhi_detail">
      <p class="f20" style="text-indent: 2em;">本《拍卖须知》根据《中华人民共和国民事诉讼法》等相关法律规定所制订，竞买人应认真仔细阅读，了解本须知的全部内容。拍卖活动遵循“公开、公平、公正、诚实守信”的原则，拍卖活动具备法律效力。参加本次拍卖活动的竞买人必须遵守本须知的各项条款，并对自己的行为承担法律责任。</p>
      <p class="xuzhi_tit">一、拍卖标的：</p>
      <p class="f16" style="text-indent: 2em;">拍卖标的对应的资产外观、结构、固定装修、内在质量及商标的登记状态以移交时的现状为准。生产性设备的实际运行状况以交接时的现状为准，拍卖人对设备外观、质量、结构、维修、运行等情况不作担保。房地产的实际面积以权证登记数字为准，拍卖人对房屋外观、质量问题、结构调整、固定装修损坏、房地产面积差异等不作担保，由买受人自行承担相关责任，由此产生的问题也不影响拍卖成交结果及成交价格。</p>
      <p class="xuzhi_tit">二、现场查验：</p>
      <p class="f16" style="text-indent: 2em;">本次拍卖是经法定公告期和展示期后才举行的，就拍卖标的物已知及可能存在的瑕疵已在本次拍卖资料中作了详尽的说明。管理人对拍卖标的物所作的说明和提供的视频资料、图片等，仅供竞买人参考，不构成对标的物的任何担保。所以请竞买人在拍卖前必须仔细审查拍卖标的物，调查是否存在瑕疵，认真研究查看所竞买标的物的实际情况，并请亲临展示现场，实地看样，未看样的竞买人慎重决定竞买行为，竞买人一旦作出竞买决定，即表明已完全了解，并接受标的物的现状和一切已知及未知的瑕疵。</p>
      <p class="xuzhi_tit">三、竞买人要求：</p>
      <p>1.凡具备完全民事行为能力的公民、法人和其他组织均可参加竞买，若不具有完全民事行为能力其委托人或代理人必须具备完全民事行为能力。</p>
      <p>2.法律、行政法规、司法解释对买受人资格或者条件有特殊规定的（比如商品房限购等），竞买人应当具备规定的资格或者条件。因不符合条件参加竞买的，由竞买人自行承担相应的法律责任。</p>
      <p>3.竞买人可委托代理人（具备完全民事行为能力的自然人）进行，但须在竞买开始前与管理人沟通办理委托手续；竞买成功后，竞买人（法定代表人、其他组织的负责人）须与委托代理人一同到管理人处办理交付或权属转移手续。如委托手续不全，竞买活动认定为委托代理人的个人行为。</p>
      <p>4.竞买人注册账户信息时，须提交单位或者个人的相关信息，在拍卖平台审核后才能以其对应的名义参与竞拍，竞买人提供的账号信息与收付保证金的账户信息一致。</p>
      <p class="xuzhi_tit">四、优先购买人：</p>
      <p>1.优先购买权人参加竞买的，标的物竞拍前向管理人提交合法有效的证明，资格经管理人确认后才能参与竞买，逾期不提交的，视为放弃对本标的物享有优先购买权。</p>
      <p>2.优先购买权人参与竞买的，以与其他竞买人以相同的价格出价，没有更高出价的，拍卖财产由优先购买权人竞得。</p>
      <p>3.顺序不同的优先购买权人申请参与竞买的，管理人应当确认其顺序，赋予不同顺序的优先竞买代码。顺序不同的优先购买权人以相同价格出价的，拍卖财产由顺序在先的优先购买权人竞得。顺序相同的优先购买权人以相同价格出价的，拍卖财产由出价在先的优先购买权人竞得。</p>
      <p class="xuzhi_tit">五、拍卖方式：</p>
      <p class="xuzhi-con2">拍卖采取有保留价或无保留价的增价拍卖方式，每次出价金额必须是加价幅度规定金额的整数倍。1.有保留价：至少一人报名且出价不低于保留价，方可成交，出价低于保留价时，标的流拍；2.无保留价：① 一人报名，即视为接受标的底价，已满足成交条件，即可成交。② 无人报名，标的流拍。③ 两人或两人以上报名，均未出价，最先报名成功者判定为买受人。</p>
      <p class="xuzhi_tit">六、拍卖延时：</p>
      <p>本次拍卖活动设置延时出价功能，在拍卖活动自由竞价时间过后自动进入限时竞价时间。</p>
      <p class="xuzhi_tit">七、收费说明：</p>
      <!-- <p>1.平台服务费按拍卖成交价5%以下收取。</p> -->
      <p>1.{{ serviceFeeText }}</p>
      <p>2.竞拍成功后，买家除支付拍品的货款外还需支付和拍品相关杂费（例如：物流费、拆迁费、人工费、保险费、税费等），买方需要在拍卖之前进行了解，并明确自己应该负担的各项费用，如果在未知晓的情况下竞拍成功，视同已经了解各项费用承担金额。</p>
      <p class="xuzhi_tit">八、保证金说明：</p>
      <p>1.保证金的缴纳：</p>
      <!-- <p>保证金是送拍人、竞拍人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金（吉林省崇晟科贸有限公司开户行:{{$global.account_bank+$global.account_number}}。</p> -->
      <p>保证金是送拍人、竞拍人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金。</p>
      <p>2.保证金的返还：</p>
      <p>A.用户未成功竞拍商品：保证金返还时限为5个工作日。</p>
      <p>B..用户竞拍成功后，送拍人主动关闭交易或未履约发货或因商家其他原因导致交易未完成的；竞拍结束后，系统会自动在5个工作日内将款项退还到支付账号中。</p>
      <p>C.注：竞拍人缴纳的保证金仅用于履约保证，返还时不计利息，请知悉</p>
      <p>3.保证金的扣除：</p>
      <p>A.在升价拍竞拍成功之时起的3个工作日内未按照成交价格支付货款的。</p>
      <p>B.送拍机构主动关闭交易或未履行发货协议而导致交易未完成的。</p>
      <p>C.标的物流拍之后，送拍人打算重新拍卖的。</p>
      <p>4.保证金抵佣金：</p>
      <p>用户竞拍成功后，竞买保证金即转为成交保证金,用户完成标的交割手续后，保证金将全部或部分抵扣佣金。如保证金金额小于应支付佣金金额，用户应立即补齐；如保证金金额大于应支付佣金金额，平台将于扣除佣金后3个工作日内将剩余保证金无息返还用户。</p>
      <p>5.违约赔偿：</p>
      <p>A.用户竞拍成功并支付成交款后，如因送拍机构原因出现了“成交不卖”的违规行为，送拍人关闭交易或未履约发货，送拍机构应为竞买人办理退款，同时，竞拍人还将获得由送拍机构所缴纳保证金金额一倍的违约金作为赔偿。</p>
      <p>B.买受人逾期未支付拍卖余款或未办理交接手续，管理人可提请重新拍卖。重新拍卖时，原买受人不得参加竞买。拍卖成交后买受人悔拍的，交纳的保证金不予退还，依次用于支付拍卖产生的费用损失、弥补重新拍卖价款低于原拍卖价款的差价等。</p>
      <p class="xuzhi_tit">九、资产交割：</p>
      <p class="xuzhi-con2">标的成交后，买受人应于标的成交之日起3个工作日内与送拍人办理货物交割手续，并由管理人协助办理过户手续，逾期不办理的，承担本标的物可能发生的损毁、灭失等后果。</p>
      <p class="xuzhi_tit">十、其他规定：</p>
      <p>1.因注册信息不准确、资料提供不完善、竞买保证金交纳不及时，造成申请人用户名不能被审核通过，从而不能登录竞价大厅，我公司不承担任何责任。</p>
      <p>2.竞买人的竞买账号和密码一经转交给竞买人后，因泄露、丢失、遗忘登录密码而产生的一切后果，我公司不承担任何责任。</p>
      <p>3.由于本次拍卖为网络拍卖，竞买人在规定的时间凭账号及密码登陆交易系统进行报价，凡以竞买人的账号和密码登陆交易系统进行的操作，均被视为竞买人的行为，竞买人应当对以其账号进行的所有活动和事件负法律责任。由于网络拍卖对于时间要求的严格性，竞买人在规定时间段内未登录交易系统报价的，视为自愿放弃竞买资格。由于竞买人自身原因导致不能登录交易系统进行报价的，后果由竞买人自行承担。竞买人应当谨慎报价，报价一经提交，不得修改或者撤回。网上交易过程中所涉及的时间，以交易系统服务器时间为准。</p>
      <p>4.由于互联网可能出现不稳定情况，不排除网络竞价发生故障（包括但不限于网络故障、电路故障、系统故障）以及被网络黑客恶意攻击，或因竞买人自身终端设备和网络异常等原因导致无法正常竞价的，我公司不承担任何责任。</p>
      <p>5.对于因不可抗力或本系统程序不能控制的因素导致服务中断、报价中断或其他缺陷，我公司不承担任何责任。</p>
      <p>6.参加竞买的人应当遵守拍卖须知的规定，不得阻挠其他竞买人竞拍，不得操纵、垄断竞拍价格，严禁竞买人恶意串标，上述行为一经发现，将取消其竞买资格，并追究相关的法律责任。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BiaodiIntroduce',
  props: {
    serviceFeeText: {
      type: String,
      default: '平台服务费按拍卖成交价5%以下收取。'
    }
  }
}
</script>